import { ILegalDocumentVersion } from "../LegalDocuments/LegalDocuments";
import { IPayment, IPaymentPlan } from "../Payment";
import { IResponse } from "../Response";

/** Mirrors Prisma `TermsAcceptanceContext` from the API (`@dbclient`). */
export enum TermsAcceptanceContext {
  FullPayment = "FullPayment",
  DownPayment = "DownPayment",
  PayRemaining = "PayRemaining",
}

export interface ITermsAcceptancePayment extends IPayment {
  paymentPlan?: IPaymentPlan | null;
}

export interface ICreateTermsAcceptanceRequest {
  orderId: string;
  acceptanceContext: TermsAcceptanceContext;
  termsVersion: string;
  privacyPolicyVersion: string;
  ipAddress?: string;
  userAgent?: string;
  amountInCents?: number;
  userId?: string;
}

export interface ITermsAcceptanceUser {
  id: string;
  name: string;
}

export interface ITermsAcceptance {
  id: string;
  orderId: string;
  patientId: string;
  paymentId: string | null;
  userId: string | null;
  acceptanceContext: TermsAcceptanceContext;
  termsAndConditionsVersionId: string;
  privacyPolicyVersionId: string;
  acceptanceSnapshot: Record<string, unknown> | null;
  amountInCents: number | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
  updatedAt: string;
  payment?: ITermsAcceptancePayment | null;
  user?: ITermsAcceptanceUser | null;
  termsAndConditionsContent?: string | null;
  privacyPolicyContent?: string | null;
  termsAndConditionsVersion?: ILegalDocumentVersion | null;
  privacyPolicyVersion?: ILegalDocumentVersion | null;
}

export interface ICreateTermsAcceptanceResponse extends IResponse {
  data: ITermsAcceptance;
}
